import { DeleteTenantResponse } from '@hakimo-ui/hakimo/types';
import { useAuthenticatedMutation } from '../shared/useAuthenticatedMutation';

export function useDeleteTenant(
  tenantId: string,
  onSuccess?: (data: DeleteTenantResponse) => void,
  onError?: (err: Error) => void
) {
  const url = `/v2/orm/admin/tenants/${tenantId}`;
  const request = new Request(url, { method: 'DELETE' });

  return useAuthenticatedMutation<DeleteTenantResponse, void>(request, {
    onSuccessInvalidationKeys: [
      ['admin-tenants'],
      ['admin-tenant-details', tenantId],
    ],
    onSuccess,
    onError,
  });
}
